var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:{center:_vm.position==='center'},attrs:{"id":"backtotop"},on:{"click":_vm.scrollToTop}},[_c('div',{staticClass:"backtotop-arrow"})])}
var staticRenderFns = []

export { render, staticRenderFns }